import { render, staticRenderFns } from "./NewFund.vue?vue&type=template&id=9d142d0c&scoped=true"
import script from "./NewFund.vue?vue&type=script&lang=js"
export * from "./NewFund.vue?vue&type=script&lang=js"
import style0 from "./NewFund.vue?vue&type=style&index=0&id=9d142d0c&prod&lang=scss&scoped=true"
import style1 from "./NewFund.vue?vue&type=style&index=1&id=9d142d0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d142d0c",
  null
  
)

export default component.exports